import React from "react";
import { FluidSectionViewer } from "./FluidPreview/FluidSectionViewer";
export const FluidViewer = ({
  data,
  sectionId,
  wuiltContext
}) => {
  return /*#__PURE__*/React.createElement(FluidSectionViewer, {
    sectionData: data,
    sectionId: sectionId,
    wuiltContext: wuiltContext
  });
};
//# sourceMappingURL=FluidViewer.js.map